import React, { useState } from "react";
import styled from "@emotion/styled";
import { User } from "@ecologi/shared";
import { Button } from "../../Button";
import { TextField } from "../../TextField";
import { Modal, ModalHeaderSection } from "../../DeprecatedModal";
import { Link } from "../../Link";
import { useRouter } from "next/router";

type AlbertModalProps = {
  close: () => void;
  profile: User; // current profile donating to
  isAlbertModalOpen: boolean;
  isAlbertConfirmationModalOpen: boolean;
  setAlbertModalState: any;
  setalbertConfirmationModal: any;
  createPaymentLink: any;
};

const ModalContentWrapper = styled.div`
  padding: 0px 44px 44px 44px;
`;

const BespokeModalTitle = styled.div`
  font-weight: bold;
  font-family: "Sofia Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  margin: 0px 0px 22px 0px;
`;

const BespokeModalDescription = styled.div`
  font-family: "Sofia Pro";
  font-style: normal;
  font-size: 16px;
  margin: 20px 40px 50px 0px;
`;

const BespokeModalInputFormWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    flex-direction: column;
  }
`;

const ButtonWrapper = styled.div`
  max-height: 50px;
  margin-bottom: -20px;
  min-width: 180px;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    width: 100%;
    margin-bottom: 0px;
  }
`;

const Wrapper = styled.div`
  width: 720px;
  max-width: 90vw;
`;

const WideWrapper = styled.div`
  width: 100%;
  max-width: 800px;

  @media ${({ theme }) => theme.bp.tabletDown} {
    max-width: 90vw;
  }
`;

const CalculationCostFormWrapper = styled.div``;

const CalculationButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    flex-direction: column-reverse;
    gap: 24px;
  }
`;

const CalculationCostText = styled.div`
  background: #f9f9f9;
  padding: 16px 0px 44px 20px;
  margin: 23px 0px;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    padding: 16px 0px 35px 20px;
  }
`;

const BespokeModalFooter = styled.div`
  font-size: 12px;
  margin-top: 60px;
  margin-bottom: 10px;
`;

const BespokeBaftaAlbertWrapper = styled.div`
  display: block;
  margin: 15px auto 0;
`;

const SuccessModalWrapper = styled.div`
  display: block;
  margin: 15px auto 0;
`;

const SuccessWrapper = styled.div`
  display: flex;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    flex-direction: column;
  }
`;

const MobileSpacer = styled.div`
  display: none;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    display: flex;
    padding: 30px;
    background-color: snow;
  }
`;

const SuccessInnerLeft = styled.div`
  display: flex;
  background-color: #0a9e76;
  padding: 40px 40px;
  flex: 1;
  @media ${({ theme }) => theme.bp.extraSmallDown} {
    display: block;
    padding: 0px;
  }
`;

const SuccessInner = styled.div`
  display: flex;
  padding: 50px 55px 50px 35px;
  flex-direction: column;
  flex: 1;
`;

const SuccessImage = styled.svg`
  width: 100%;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    display: none;
  }
`;

const SuccessImageMobile = styled.svg`
  display: none;

  @media ${({ theme }) => theme.bp.extraSmallDown} {
    display: block;
  }
`;

const SuccessParagraph = styled.div`
  margin-bottom: 20px;
`;

export const AlbertModal: React.FC<AlbertModalProps> = (props) => {
  const router = useRouter();

  const {
    isAlbertModalOpen,
    isAlbertConfirmationModalOpen,
    setAlbertModalState,
    setalbertConfirmationModal,
    profile,
    createPaymentLink,
  } = props;

  const [tonnes, setTonnes] = useState("");
  const [buyEnabled, setBuyEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState<number | null>(null);
  const [errorMessage, setErrorMessage] = useState("");

  const useSetTonnes = (value: string) => {
    setErrorMessage("");
    setCalculatedPrice(null);
    setBuyEnabled(false);
    setTonnes(value);
  };

  const onSubmitHandler = () => {
    setErrorMessage("");
    const number = +tonnes;
    if (isNaN(number)) {
      setErrorMessage("Ooops! Please enter a valid number.");
    } else if (number < 0.1) {
      setErrorMessage("Ooops! Quantity needs to be more than 0.1");
    } else {
      setCalculatedPrice(+number.toFixed(2) * 10.5);
      setBuyEnabled(true);
    }
  };

  const createPrice = async (
    tonnesRaw: string,
    calculatedPrice: number,
    profile: any
  ) => {
    setIsLoading(true);
    const username = profile.parentProfile?.username
      ? `${profile.parentProfile?.username}/${profile.username}`
      : `${profile.username}`;
    const displayName = profile.billingCompanyName;
    const tonnes = Number(tonnesRaw).toFixed(2);
    const data = await createPaymentLink({
      tonnes,
      calculatedPrice,
      username,
      displayName,
    });
    router.push(data.url);
  };

  return (
    <>
      <BespokeBaftaAlbertWrapper>
        <Modal
          key={"albertModal"}
          onClose={() => {
            setAlbertModalState(false);
            setCalculatedPrice(null);
            setTonnes("");
            router.replace(`/${profile.username}`, undefined, {
              shallow: true,
            });
          }}
          isOpen={isAlbertModalOpen}
          withCloseText
        >
          <Wrapper>
            <ModalHeaderSection>
              <ModalContentWrapper>
                <BespokeModalTitle>Request impact</BespokeModalTitle>
                <BespokeModalDescription>
                  Enter the amount of impact in tonnes you would like to add to
                  your Albert profile.
                  <strong>
                    {" "}
                    We will calculate the price and you'll be able to make a
                    card payment via our payment provider Stripe.
                  </strong>{" "}
                  Your impact will then be added to your profile within 1
                  working day.
                </BespokeModalDescription>
                <BespokeModalInputFormWrapper>
                  <TextField
                    key={"tonnedInput"}
                    label="Enter quantity in tonne CO2e"
                    name="tonnes"
                    onChange={(event) => {
                      useSetTonnes(event.target.value);
                    }}
                    errorText={errorMessage}
                    isInvalid={!!errorMessage}
                    placeholder="Minimum 0.1 tonne CO2e"
                    value={tonnes}
                  />
                  <ButtonWrapper>
                    <Button
                      darkGreen
                      text="Calculate"
                      onClick={onSubmitHandler}
                      fullWidth
                      disabled={!!!tonnes}
                    />
                  </ButtonWrapper>
                </BespokeModalInputFormWrapper>
                {calculatedPrice && (
                  <CalculationCostFormWrapper>
                    <CalculationCostText>
                      You’ll offset {Number(tonnes).toFixed(2)} tonnes CO2e for{" "}
                      <strong>£{calculatedPrice.toFixed(2)}</strong>{" "}
                      <small>(£10.50 per tonne)</small>
                    </CalculationCostText>
                    <CalculationButtonsWrapper>
                      <Button
                        invert
                        text="Cancel"
                        onClick={() => {
                          setCalculatedPrice(null);
                        }}
                      />
                      <Button
                        primary
                        text="Pay via Stripe"
                        onClick={() =>
                          createPrice(tonnes, calculatedPrice, profile)
                        }
                        disabled={!buyEnabled || isLoading}
                        loading={isLoading}
                      />
                    </CalculationButtonsWrapper>
                  </CalculationCostFormWrapper>
                )}
                <BespokeModalFooter>
                  If your payment is for <strong>over £500</strong> and you'd
                  rather pay by invoice, please send an email to{" "}
                  <strong>albertoffsets@ecologi.com</strong>.
                </BespokeModalFooter>
              </ModalContentWrapper>
            </ModalHeaderSection>
          </Wrapper>
        </Modal>
      </BespokeBaftaAlbertWrapper>

      {isAlbertConfirmationModalOpen && (
        <SuccessModalWrapper>
          <Modal
            onClose={() => {
              setAlbertModalState(false);
              setalbertConfirmationModal(false);
              router.replace(`/${profile.username}`, undefined, {
                shallow: true,
              });
            }}
            isOpen={isAlbertConfirmationModalOpen}
            withCloseText
          >
            <WideWrapper>
              <ModalHeaderSection variant="skinny">
                <>
                  <SuccessWrapper>
                    <MobileSpacer />
                    <SuccessInnerLeft>
                      <SuccessImageMobile
                        viewBox="0 0 327 200"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="-4"
                          y="-88"
                          width="332"
                          height="374"
                          fill="#0A9E76"
                        />
                        <path
                          opacity="0.1"
                          d="M108.028 45.3074V81.8537L147.307 99.6145L186.158 81.5121V45.6489L147.733 26.5219L108.028 45.3074Z"
                          fill="#222222"
                        />
                        <path
                          opacity="0.3"
                          d="M172.919 75.824C178.491 75.824 183.008 75.2662 183.008 74.5782C183.008 73.8902 178.491 73.3325 172.919 73.3325C167.347 73.3325 162.83 73.8902 162.83 74.5782C162.83 75.2662 167.347 75.824 172.919 75.824Z"
                          fill="#222222"
                        />
                        <path
                          d="M183.601 53.087C183.601 53.087 183.601 58.6933 181.82 60.5623C180.04 62.4314 176.479 63.6771 175.292 62.7445C174.106 61.8118 173.215 59.318 174.699 57.4494C176.183 55.5809 178.853 54.9575 180.634 54.6463C181.752 54.4233 182.783 53.8818 183.601 53.087Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M161.643 57.136C161.643 57.136 164.906 55.2674 167.281 55.5791C169.655 55.8908 171.435 57.136 172.028 59.3163C172.622 61.4965 171.356 62.7759 169.951 63.3656C168.468 63.9885 166.687 63.3656 165.5 60.8737C164.312 58.3818 161.643 57.136 161.643 57.136Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M174.106 73.9556C174.106 73.9556 173.512 75.2013 172.028 73.9556C172.028 73.9556 172.622 69.5946 172.622 68.3489C172.783 67.1991 172.682 66.0277 172.325 64.9229C171.731 63.3655 169.061 60.8736 168.468 60.2507C167.874 59.6278 166.687 58.6933 167.282 58.6933C167.876 58.6933 169.359 59.3162 170.842 60.8755C172.326 62.4348 173.513 63.9902 173.513 63.9902C173.513 63.9902 174.997 60.8755 175.885 59.9414C176.774 59.0074 179.149 56.2038 180.039 56.8266C180.929 57.4495 178.555 58.6952 177.962 59.3181C177.368 59.9409 174.698 63.9902 174.401 65.236C174.104 66.4817 174.106 73.9556 174.106 73.9556Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.3"
                          d="M149.27 54.9512C154.842 54.9512 159.359 54.3935 159.359 53.7055C159.359 53.0175 154.842 52.4597 149.27 52.4597C143.698 52.4597 139.181 53.0175 139.181 53.7055C139.181 54.3935 143.698 54.9512 149.27 54.9512Z"
                          fill="#222222"
                        />
                        <path
                          d="M138.588 32.2145C138.588 32.2145 138.588 37.8207 140.368 39.6898C142.149 41.5588 145.709 42.8045 146.896 41.8719C148.083 40.9393 148.974 38.4455 147.49 36.5769C146.006 34.7083 143.336 34.085 141.555 33.7738C140.437 33.5507 139.406 33.0093 138.588 32.2145Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M160.546 36.263C160.546 36.263 157.282 34.3944 154.908 34.7061C152.534 35.0178 150.754 36.263 150.16 38.4428C149.567 40.6226 150.833 41.9025 152.238 42.4921C153.721 43.115 155.502 42.4921 156.689 40.0002C157.876 37.5083 160.546 36.263 160.546 36.263Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M148.083 53.083C148.083 53.083 148.676 54.3287 150.16 53.083C150.16 53.083 149.567 48.722 149.567 47.4763C149.405 46.3265 149.507 45.1552 149.864 44.0503C150.457 42.4929 153.127 40.001 153.721 39.3781C154.314 38.7553 155.501 37.8208 154.907 37.8208C154.312 37.8208 152.83 38.4436 151.346 40.0029C149.862 41.5622 148.675 43.1177 148.675 43.1177C148.675 43.1177 147.192 40.0029 146.303 39.0689C145.415 38.1348 143.039 35.3312 142.149 35.9541C141.259 36.5769 143.632 37.8208 144.226 38.4431C144.819 39.0655 147.489 43.1153 147.786 44.361C148.083 45.6068 148.083 53.083 148.083 53.083Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.3"
                          d="M125.707 75.824C131.279 75.824 135.796 75.2662 135.796 74.5782C135.796 73.8902 131.279 73.3325 125.707 73.3325C120.135 73.3325 115.618 73.8902 115.618 74.5782C115.618 75.2662 120.135 75.824 125.707 75.824Z"
                          fill="#222222"
                        />
                        <path
                          d="M133.458 58.6217C132.125 58.5153 130.783 58.5599 129.459 58.7545C128.58 58.8607 127.757 59.2412 127.107 59.8421C126.457 60.4429 126.013 61.2335 125.838 62.1013C125.634 62.7865 125.697 63.5236 126.015 64.1642C126.333 64.8047 126.881 65.3011 127.55 65.5534C128.722 66.0567 129.961 65.4585 131.408 63.672C132.533 62.2039 133.242 60.4591 133.458 58.6217Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M116.534 57.5092C116.721 58.9444 117.046 60.3583 117.504 61.7312C118.19 63.6221 119.486 64.8298 121.282 64.8659C123.077 64.9019 123.828 63.5927 124.02 62.3123C124.223 60.9608 123.422 59.771 121.509 58.615C120.006 57.7379 118.267 57.3513 116.534 57.5092Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M124.767 73.9557C124.767 73.9557 125.313 74.5686 126.351 73.9557C126.351 73.9557 126.004 71.2015 126.004 69.9558C125.843 68.806 125.944 67.6347 126.3 66.5298C126.807 65.3183 127.562 64.2259 128.515 63.3225C129.108 62.6996 130.34 61.4478 129.748 61.4478C129.157 61.4478 128.278 62.0327 126.793 63.5901C125.308 65.1474 125.115 65.5953 125.115 65.5953C125.115 65.5953 123.743 63.721 122.852 62.7869C121.962 61.8529 120.709 60.3771 119.651 60.3771C119.158 60.3771 121.273 62.9672 121.867 63.5901C122.46 64.2129 123.929 65.5953 124.226 66.841C124.522 68.0867 124.767 73.9557 124.767 73.9557Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.1"
                          d="M198.267 45.161V81.6883L237.545 99.4491L276.397 81.3466V45.4834L237.972 26.3565L198.267 45.161Z"
                          fill="#222222"
                        />
                        <path
                          opacity="0.078"
                          d="M212.617 74.6768C217.862 74.6768 222.114 74.1437 222.114 73.4861C222.114 72.8285 217.862 72.2954 212.617 72.2954C207.372 72.2954 203.12 72.8285 203.12 73.4861C203.12 74.1437 207.372 74.6768 212.617 74.6768Z"
                          fill="black"
                        />
                        <path
                          d="M213.878 73.339L212.616 49.8287H211.957L211.359 73.339C211.359 73.339 212.099 73.7043 213.878 73.339Z"
                          fill="white"
                        />
                        <path
                          d="M212.579 50.0232C212.579 50.0232 206.711 59.0365 207.019 60.2889C207.327 61.5412 212.887 53.2014 212.887 53.2014C212.887 53.2014 213.115 50.7917 212.579 50.0232Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M209.396 58.1068L208.248 57.2102C207.886 57.8714 207.558 58.5506 207.266 59.2453L208.015 59.7623C208.409 59.3448 208.893 58.7614 209.396 58.1068Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M212.256 49.549C212.256 49.549 206.184 40.6639 204.917 40.4741C203.651 40.2844 209.187 48.6097 209.187 48.6097C209.187 48.6097 211.336 49.7577 212.256 49.549Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M205.999 43.5004L207.266 42.7888C206.798 42.1983 206.297 41.6344 205.767 41.1L204.998 41.5743C205.254 42.1199 205.61 42.7888 205.999 43.5004Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M212.593 50.0327C212.593 50.0327 223.352 50.4027 224.253 49.4919C225.154 48.5811 215.159 48.1303 215.159 48.1303C215.159 48.1303 212.972 49.1694 212.593 50.0327Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M221.179 48.5854L221.003 50.0085C221.758 49.98 222.51 49.9121 223.257 49.8047L223.314 48.8939C222.73 48.7896 221.981 48.6708 221.179 48.5854Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M212.82 48.1966H212.19C212.075 48.1928 211.96 48.2118 211.852 48.2524C211.745 48.2931 211.646 48.3547 211.562 48.4336C211.478 48.5125 211.411 48.6074 211.364 48.7125C211.317 48.8175 211.291 48.9307 211.288 49.0458V49.2686V49.4917L211.227 51.4698L213.599 51.2565L213.665 49.5676V49.3446V49.1217C213.671 49.0053 213.654 48.8888 213.615 48.7789C213.576 48.6691 213.515 48.5681 213.437 48.482C213.358 48.3959 213.263 48.3262 213.157 48.2772C213.052 48.2282 212.937 48.2008 212.82 48.1966Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M212.455 50.4405C212.817 50.4405 213.11 50.1474 213.11 49.7859C213.11 49.4243 212.817 49.1312 212.455 49.1312C212.094 49.1312 211.801 49.4243 211.801 49.7859C211.801 50.1474 212.094 50.4405 212.455 50.4405Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M263.859 74.6768C269.104 74.6768 273.356 74.1437 273.356 73.4861C273.356 72.8285 269.104 72.2954 263.859 72.2954C258.614 72.2954 254.362 72.8285 254.362 73.4861C254.362 74.1437 258.614 74.6768 263.859 74.6768Z"
                          fill="black"
                        />
                        <path
                          d="M265.116 73.339L263.854 49.8287H263.2L262.597 73.339C262.597 73.339 263.342 73.7043 265.116 73.339Z"
                          fill="white"
                        />
                        <path
                          d="M263.821 50.0232C263.821 50.0232 257.948 59.0365 258.261 60.2889C258.575 61.5412 264.125 53.2014 264.125 53.2014C264.125 53.2014 264.348 50.7917 263.821 50.0232Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M260.633 58.1068L259.49 57.2102C259.127 57.8714 258.798 58.5507 258.503 59.2453L259.253 59.7623C259.741 59.2339 260.201 58.6815 260.633 58.1068Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M263.499 49.549C263.499 49.549 257.427 40.6639 256.155 40.4741C254.884 40.2844 260.425 48.6097 260.425 48.6097C260.425 48.6097 262.578 49.7577 263.499 49.549Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M257.261 43.5004L258.527 42.7888C258.057 42.2005 257.557 41.6368 257.028 41.1L256.26 41.5743C256.56 42.2333 256.894 42.8762 257.261 43.5004Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M263.835 50.0327C263.835 50.0327 274.59 50.4027 275.496 49.4919C276.402 48.5811 266.397 48.1303 266.397 48.1303C266.397 48.1303 264.215 49.1694 263.835 50.0327Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M272.412 48.5854L272.237 50.0085C272.989 49.9801 273.74 49.9121 274.485 49.8047L274.542 48.8939C273.968 48.7896 273.219 48.6708 272.412 48.5854Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M264.058 48.1966H263.432C263.317 48.1928 263.202 48.2118 263.094 48.2524C262.986 48.2931 262.887 48.3545 262.803 48.4333C262.719 48.5122 262.651 48.6069 262.604 48.712C262.556 48.8171 262.53 48.9305 262.526 49.0458V49.2686V49.4917L262.465 51.4698L264.836 51.2565L264.908 49.5676V49.1217C264.914 49.0049 264.897 48.8879 264.858 48.7778C264.818 48.6676 264.757 48.5665 264.678 48.4804C264.599 48.3942 264.503 48.3246 264.397 48.2758C264.29 48.2271 264.175 48.2002 264.058 48.1966Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M263.698 50.4405C264.059 50.4405 264.352 50.1474 264.352 49.7859C264.352 49.4243 264.059 49.1312 263.698 49.1312C263.336 49.1312 263.043 49.4243 263.043 49.7859C263.043 50.1474 263.336 50.4405 263.698 50.4405Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M222.93 45.9626C226.333 45.9626 229.092 45.6164 229.092 45.1893C229.092 44.7623 226.333 44.4161 222.93 44.4161C219.526 44.4161 216.767 44.7623 216.767 45.1893C216.767 45.6164 219.526 45.9626 222.93 45.9626Z"
                          fill="black"
                        />
                        <path
                          d="M223.745 45.08L222.925 29.8239H222.498L222.109 45.08C222.109 45.08 222.602 45.3504 223.745 45.08Z"
                          fill="white"
                        />
                        <path
                          d="M222.892 29.6436C222.892 29.6436 228.485 33.8228 229.305 33.671C230.126 33.5192 224.96 29.5771 224.96 29.5771C224.96 29.5771 223.409 29.3257 222.892 29.6436Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M227.991 32.0681L227.365 32.775C227.839 33.0739 228.29 33.3298 228.636 33.4958L229.006 33.0214C228.769 32.7321 228.39 32.4001 227.991 32.0681Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M222.569 29.8338C222.569 29.8338 216.559 33.3917 216.402 34.2028C216.245 35.014 221.853 31.7693 221.853 31.7693C221.853 31.7693 222.664 30.4363 222.569 29.8338Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M218.395 33.6191L217.982 32.77C217.581 33.0482 217.194 33.3475 216.824 33.6666L217.114 34.1836C217.465 34.0555 217.911 33.8516 218.395 33.6191Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M222.896 29.6346C222.896 29.6346 223.589 22.6849 223.039 22.0445C222.488 21.4041 221.772 27.8793 221.772 27.8793C221.772 27.8793 222.356 29.3547 222.896 29.6346Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M222.318 24.0272L223.266 24.1981C223.28 23.7092 223.267 23.2197 223.228 22.7321L222.64 22.661C222.517 23.0168 222.417 23.5006 222.318 24.0272Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M223.077 28.7801H222.669C222.518 28.7763 222.372 28.8319 222.262 28.9349C222.152 29.0378 222.087 29.1799 222.08 29.3305V29.6198L222.038 30.9007L223.579 30.7631L223.627 29.6673V29.378C223.631 29.3024 223.619 29.2268 223.594 29.1556C223.568 29.0845 223.528 29.0192 223.477 28.9636C223.426 28.9079 223.364 28.8631 223.295 28.8316C223.227 28.8001 223.152 28.7826 223.077 28.7801Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M222.821 30.2368C223.056 30.2368 223.248 30.0457 223.248 29.8099C223.248 29.5741 223.056 29.3829 222.821 29.3829C222.585 29.3829 222.394 29.5741 222.394 29.8099C222.394 30.0457 222.585 30.2368 222.821 30.2368Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M250.311 46.1284C253.714 46.1284 256.473 45.7822 256.473 45.3552C256.473 44.9281 253.714 44.5819 250.311 44.5819C246.908 44.5819 244.149 44.9281 244.149 45.3552C244.149 45.7822 246.908 46.1284 250.311 46.1284Z"
                          fill="black"
                        />
                        <path
                          d="M251.127 45.2412L250.306 29.9899H249.884L249.495 45.2412C249.495 45.2412 249.974 45.4974 251.127 45.2412Z"
                          fill="white"
                        />
                        <path
                          d="M250.296 30.2412C250.296 30.2412 247.27 36.5362 247.573 37.3094C247.877 38.0826 250.757 32.2573 250.757 32.2573C250.757 32.2573 250.709 30.6918 250.296 30.2412Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M248.921 35.7065L248.11 35.2321C247.927 35.6865 247.768 36.1506 247.635 36.6221L248.162 36.8924C248.39 36.5888 248.651 36.1713 248.921 35.7065Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M250.05 29.9615C250.05 29.9615 245.401 24.7433 244.571 24.7433C243.741 24.7433 248.006 29.6247 248.006 29.6247C248.006 29.6247 249.476 30.1703 250.05 29.9615Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M245.529 26.5938L246.288 26.0293C245.937 25.693 245.568 25.3763 245.183 25.0805L244.708 25.4599C244.922 25.7635 245.206 26.1668 245.529 26.5938Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M250.306 30.2462C250.306 30.2462 257.261 29.5867 257.763 28.9273C258.266 28.2679 251.796 28.8087 251.796 28.8087C251.796 28.8087 250.477 29.658 250.306 30.2462Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M255.7 28.6001V29.5489C256.179 29.4667 256.655 29.3589 257.123 29.2262L257.085 28.6381C256.624 28.6026 256.162 28.5899 255.7 28.6001Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M250.444 28.9464H250.031C249.956 28.9445 249.882 28.9575 249.812 28.9844C249.742 29.0113 249.678 29.0514 249.624 29.103C249.57 29.1545 249.526 29.2162 249.496 29.2846C249.466 29.3529 249.449 29.4266 249.448 29.5014V29.7909L249.405 31.0716L250.951 30.934L250.994 29.8382V29.5489C250.998 29.4729 250.988 29.3968 250.962 29.3251C250.937 29.2534 250.897 29.1876 250.846 29.1315C250.795 29.0753 250.733 29.0301 250.664 28.9983C250.594 28.9665 250.52 28.9488 250.444 28.9464Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M250.207 30.4027C250.442 30.4027 250.633 30.2115 250.633 29.9757C250.633 29.7399 250.442 29.5488 250.207 29.5488C249.971 29.5488 249.78 29.7399 249.78 29.9757C249.78 30.2115 249.971 30.4027 250.207 30.4027Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M236.079 87.5607C243.926 87.5607 250.287 87.0276 250.287 86.37C250.287 85.7124 243.926 85.1793 236.079 85.1793C228.233 85.1793 221.872 85.7124 221.872 86.37C221.872 87.0276 228.233 87.5607 236.079 87.5607Z"
                          fill="black"
                        />
                        <path
                          d="M238.389 86.1186L236.539 51.6406H235.591L234.708 86.1186C234.708 86.1186 235.785 86.6926 238.389 86.1186Z"
                          fill="white"
                        />
                        <path
                          d="M236.459 51.2281C236.459 51.2281 249.106 60.6776 250.956 60.3361C252.806 59.9945 241.141 51.081 241.141 51.081C241.141 51.081 237.636 50.507 236.459 51.2281Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M247.986 56.6548L246.563 58.2487C247.495 58.8434 248.458 59.3881 249.448 59.8805L250.278 58.8322C249.708 58.2107 248.897 57.4518 247.986 56.6548Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M235.738 51.6549C235.738 51.6549 222.152 59.6957 221.753 61.5363C221.355 63.3769 234.087 56.0334 234.087 56.0334C234.087 56.0334 235.951 53.0211 235.738 51.6549Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M226.293 60.2128L225.344 58.2914C224.437 58.9227 223.563 59.6005 222.726 60.3219L223.376 61.4935C224.196 61.1993 225.207 60.7393 226.293 60.2128Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M236.473 51.2089C236.473 51.2089 238.034 35.4973 236.791 34.0884C235.548 32.6794 233.945 47.2714 233.945 47.2714C233.945 47.2714 235.245 50.5685 236.473 51.2089Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M235.169 38.5288L237.265 38.9226C237.293 37.815 237.264 36.7067 237.18 35.602L235.852 35.431C235.614 36.2517 235.411 37.3382 235.169 38.5288Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M236.834 49.2782L235.913 49.2499C235.572 49.2397 235.24 49.3651 234.991 49.599C234.742 49.8329 234.596 50.1561 234.585 50.4975V50.8248V51.1521L234.495 54.0505L237.982 53.7375L238.081 51.2612V50.9339V50.6066C238.092 50.2651 237.966 49.9335 237.732 49.6845C237.498 49.4355 237.175 49.2893 236.834 49.2782Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M236.307 52.5703C236.839 52.5703 237.27 52.1392 237.27 51.6073C237.27 51.0755 236.839 50.6443 236.307 50.6443C235.775 50.6443 235.344 51.0755 235.344 51.6073C235.344 52.1392 235.775 52.5703 236.307 52.5703Z"
                          fill="white"
                        />
                        <g clip-path="url(#clip0_1_462)">
                          <path
                            opacity="0.1"
                            d="M153.247 111.327V147.855L192.526 165.615L231.377 147.513V111.669L192.953 92.5418L153.247 111.327Z"
                            fill="#222222"
                          />
                          <path
                            opacity="0.078"
                            d="M195.13 136.432C195.13 137.295 187.644 138.699 178.413 138.699C169.181 138.699 161.696 137.276 161.696 136.432C161.696 135.587 169.177 134.866 178.413 134.866C187.649 134.866 195.13 135.582 195.13 136.432Z"
                            fill="black"
                          />
                          <path
                            opacity="0.078"
                            d="M218.46 136.432C218.46 137.295 212.948 138.699 206.126 138.699C199.305 138.699 193.792 137.276 193.792 136.432C193.792 135.587 199.305 134.866 206.126 134.866C212.948 134.866 218.46 135.582 218.46 136.432Z"
                            fill="black"
                          />
                          <path
                            d="M197.687 146.991L196.582 144.539L198.147 145.767L198.555 142.945L199.314 145.492L200.263 143.191L200.509 145.431L202.165 143.865L200.813 146.991H197.687Z"
                            fill="#04513E"
                          />
                          <path
                            d="M190.144 157.632L189.039 155.179L190.604 156.403L191.012 153.585L191.767 156.128L192.715 153.827L192.962 156.066L194.618 154.505L193.266 157.632H190.144Z"
                            fill="#04513E"
                          />
                          <path
                            d="M211.809 151.849L210.704 149.396L212.269 150.62L212.677 147.802L213.432 150.345L214.38 148.044L214.622 150.283L216.278 148.718L214.931 151.849H211.809Z"
                            fill="#04513E"
                          />
                          <path
                            d="M220.6 127.736L219.499 125.284L221.06 126.507L221.472 123.69L222.227 126.232L223.175 123.932L223.422 126.171L225.078 124.61L223.73 127.736H220.6Z"
                            fill="#04513E"
                          />
                          <path
                            d="M220.011 113.713L218.906 111.261L220.471 112.49L220.879 109.667L221.634 112.214L222.582 109.914L222.829 112.153L224.485 110.587L223.133 113.713H220.011Z"
                            fill="#04513E"
                          />
                          <path
                            d="M169.063 114.752L167.957 112.3L169.523 113.528L169.931 110.706L170.685 113.253L171.634 110.953L171.876 113.192L173.531 111.626L172.184 114.752H169.063Z"
                            fill="#04513E"
                          />
                          <path
                            d="M204.499 107.276L203.398 104.824L204.959 106.047L205.372 103.225L206.126 105.772L207.075 103.472L207.322 105.711L208.977 104.145L207.63 107.276H204.499Z"
                            fill="#04513E"
                          />
                          <path
                            d="M186.107 103.225L185.002 100.777L186.567 102.001L186.975 99.1784L187.73 101.726L188.678 99.4251L188.925 101.664L190.581 100.099L189.229 103.225H186.107Z"
                            fill="#04513E"
                          />
                          <path
                            d="M186.776 116.797L185.676 114.344L187.236 115.568L187.649 112.75L188.403 115.293L189.352 112.997L189.599 115.231L191.254 113.671L189.907 116.797H186.776Z"
                            fill="#04513E"
                          />
                          <path
                            d="M158.067 125.711L156.961 123.258L158.527 124.487L158.935 121.664L159.689 124.211L160.638 121.911L160.88 124.15L162.535 122.584L161.188 125.711H158.067Z"
                            fill="#04513E"
                          />
                          <path
                            d="M179.542 147.655L178.441 145.203L180.002 146.427L180.415 143.609L181.169 146.152L182.118 143.856L182.364 146.09L184.02 144.529L182.673 147.655H179.542Z"
                            fill="#04513E"
                          />
                          <path
                            d="M160.012 146.991L158.906 144.539L160.467 145.767L160.88 142.945L161.634 145.492L162.583 143.191L162.829 145.431L164.485 143.865L163.138 146.991H160.012Z"
                            fill="#04513E"
                          />
                          <path
                            d="M168.868 130.981V131.36C167.445 131.36 166.368 132.257 166.368 133.514V136.526H166.013V133.343C165.999 133.028 166.05 132.713 166.164 132.418C166.337 131.975 166.643 131.597 167.042 131.338C167.44 131.078 167.91 130.95 168.384 130.971L168.868 130.981Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M168.868 131.36V131.797H168.394C167.984 131.798 167.591 131.961 167.3 132.251C167.01 132.54 166.845 132.933 166.843 133.343V136.526H166.368V133.514C166.378 132.257 167.146 131.36 168.868 131.36Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M169.125 129.169V129.672C167.701 129.672 163.977 129.596 163.977 132.518V136.512H163.622V132.29C163.622 129.581 167.17 129.155 168.636 129.155L169.125 129.169Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M169.125 129.672V130.042H168.65C167.796 130.042 164.452 130.042 164.452 132.304V136.526H163.977V132.532C163.958 129.719 167.384 129.672 169.125 129.672Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M166.06 132.959C166.216 132.899 166.386 132.886 166.55 132.921C166.713 132.957 166.863 133.039 166.98 133.158C167.062 133.238 167.126 133.333 167.17 133.438C167.214 133.543 167.237 133.656 167.236 133.77C167.236 133.884 167.213 133.997 167.169 134.102C167.125 134.207 167.061 134.302 166.98 134.382C166.9 134.464 166.805 134.528 166.7 134.572C166.595 134.616 166.482 134.639 166.368 134.638C166.166 134.638 165.97 134.568 165.813 134.439C165.658 134.308 165.552 134.127 165.514 133.927C165.478 133.728 165.513 133.523 165.614 133.348C165.713 133.17 165.871 133.033 166.06 132.959Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M166.06 132.959C166.18 132.916 166.308 132.898 166.435 132.907C166.563 132.918 166.688 132.957 166.8 133.021H166.667C166.562 133.021 166.457 133.04 166.359 133.078C166.194 133.143 166.052 133.255 165.951 133.4C165.854 133.54 165.801 133.705 165.799 133.875C165.799 134.027 165.84 134.177 165.916 134.308C165.993 134.44 166.103 134.549 166.235 134.624C166.053 134.595 165.886 134.504 165.761 134.368C165.628 134.23 165.544 134.052 165.524 133.861C165.503 133.67 165.547 133.478 165.647 133.315C165.75 133.152 165.904 133.027 166.084 132.959H166.06Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M163.754 132.959C163.854 132.921 163.961 132.902 164.068 132.902C164.297 132.906 164.516 132.998 164.68 133.158C164.84 133.322 164.93 133.541 164.931 133.77C164.932 133.987 164.852 134.197 164.706 134.358C164.561 134.519 164.36 134.619 164.144 134.639C163.928 134.66 163.712 134.598 163.539 134.467C163.366 134.336 163.248 134.145 163.209 133.932C163.171 133.731 163.205 133.524 163.305 133.346C163.405 133.168 163.564 133.031 163.754 132.959Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M163.754 132.959C163.875 132.913 164.005 132.894 164.134 132.905C164.263 132.916 164.388 132.955 164.499 133.021H164.366C164.259 133.02 164.153 133.04 164.053 133.078C163.89 133.143 163.75 133.256 163.65 133.4C163.553 133.54 163.5 133.705 163.498 133.875C163.496 134.027 163.535 134.177 163.611 134.309C163.687 134.441 163.797 134.55 163.93 134.624C163.743 134.592 163.572 134.501 163.442 134.363C163.312 134.225 163.23 134.049 163.209 133.86C163.185 133.672 163.227 133.481 163.327 133.32C163.427 133.156 163.577 133.03 163.754 132.959Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M175.728 121.275H171.501V126.332H175.728V121.275Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M181.814 121.275H177.587V126.332H181.814V121.275Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M183.669 122.727H181.814V123.31H183.669V122.727Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M183.669 123.22H181.814V123.4H183.669V123.22Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M183.669 124.553H181.814V125.137H183.669V124.553Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M183.669 125.046H181.814V125.227H183.669V125.046Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M177.583 122.727H175.728V123.31H177.583V122.727Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M177.583 123.22H175.728V123.4H177.583V123.22Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M177.583 124.553H175.728V125.137H177.583V124.553Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M177.583 125.046H175.728V125.227H177.583V125.046Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M189.926 126.541V126.868H190.4C190.444 125.959 190.835 125.101 191.493 124.472C192.15 123.842 193.024 123.489 193.935 123.486H196.586V123.011H193.465C192.528 123.011 191.629 123.383 190.966 124.044C190.303 124.706 189.929 125.604 189.926 126.541Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M191.145 126.868V126.541C191.146 125.926 191.391 125.337 191.826 124.902C192.261 124.467 192.85 124.222 193.465 124.221H196.586V123.486H193.935C193.024 123.489 192.15 123.842 191.493 124.472C190.835 125.101 190.444 125.959 190.4 126.868H191.145Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M215.96 117.703H196.416V136.555H215.96V117.703Z"
                            fill="white"
                          />
                          <path
                            d="M191.833 127.352H168.403V136.55H191.833V127.352Z"
                            fill="white"
                          />
                          <path
                            d="M216.819 116.683H195.552V117.698H216.819V116.683Z"
                            fill="#78716C"
                          />
                          <path
                            d="M216.819 117.703H195.552V117.969H216.819V117.703Z"
                            fill="#6D6764"
                          />
                          <path
                            d="M196.416 136.55H215.96V135.483H196.416V136.55Z"
                            fill="white"
                          />
                          <path
                            d="M186.112 136.55H191.833V135.483H186.112V136.55Z"
                            fill="white"
                          />
                          <path
                            d="M177.056 136.55H181.235V135.483H177.056V136.55Z"
                            fill="white"
                          />
                          <path
                            d="M168.403 136.55H172.236V135.483H168.403V136.55Z"
                            fill="white"
                          />
                          <path
                            opacity="0.12"
                            d="M196.416 118.495H215.96V117.969H196.416V118.495Z"
                            fill="black"
                          />
                          <path
                            opacity="0.12"
                            d="M168.403 128.139H191.833V127.613H168.403V128.139Z"
                            fill="black"
                          />
                          <path
                            d="M172.383 130.525H177.094V136.541H172.398L172.383 130.525Z"
                            fill="#847E7B"
                          />
                          <path
                            d="M174.675 136.541H174.907V130.525H174.675V136.541Z"
                            fill="#77716E"
                          />
                          <path
                            d="M181.378 130.525H186.093V136.541H181.397L181.378 130.525Z"
                            fill="#847E7B"
                          />
                          <path
                            d="M183.669 136.541H183.901V130.525H183.669V136.541Z"
                            fill="#77716E"
                          />
                          <path
                            d="M187.791 121.275H183.565V126.332H187.791V121.275Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M192.118 126.332H167.825V127.39H192.118V126.332Z"
                            fill="#78716C"
                          />
                          <path
                            d="M192.118 127.352H167.825V127.637H192.118V127.352Z"
                            fill="#6D6764"
                          />
                          <path
                            d="M226.05 137.627H212.516C211.814 134.7 214.575 136.161 214.575 136.161C214.575 136.161 213.536 133.087 214.603 133.405C215.671 133.723 216.083 136.109 216.083 136.109C216.083 136.109 216.638 132.195 217.858 131.939C218.645 131.773 218.024 135.663 218.024 135.663C218.346 135.4 218.746 135.25 219.162 135.236C219.727 135.236 219.589 135.986 219.589 135.986C219.589 135.986 220.766 133.462 221.377 133.495C222.146 133.533 221.321 136.185 221.321 136.185C221.321 136.185 222.834 134.463 223.432 134.506C224.257 134.572 222.815 137.034 222.815 137.034C223.541 136.61 224.376 136.409 225.215 136.455C226.15 136.536 226.525 136.934 226.05 137.627Z"
                            fill="#00A273"
                          />
                          <path
                            d="M190.144 138.04L189.039 135.587L190.604 136.816L191.012 133.993L191.767 136.541L192.715 134.24L192.962 136.479L194.618 134.914L193.266 138.04H190.144Z"
                            fill="#04513E"
                          />
                          <path
                            d="M206.126 126.232C207.79 126.232 209.138 124.884 209.138 123.22C209.138 121.556 207.79 120.208 206.126 120.208C204.462 120.208 203.114 121.556 203.114 123.22C203.114 124.884 204.462 126.232 206.126 126.232Z"
                            fill="#F2F2F2"
                          />
                          <path
                            d="M207.412 120.824L204.352 123.087L205.894 123.509L204.817 125.616L207.668 123.173L206.107 122.826L207.412 120.824Z"
                            fill="#FBB03B"
                          />
                          <path
                            d="M214.679 128.652H197.772V132.674H214.679V128.652Z"
                            fill="#94C4D3"
                          />
                          <path
                            d="M214.679 128.68H197.772V129.221H214.679V128.68Z"
                            fill="#6799A5"
                          />
                          <path
                            d="M208.787 133.348H209.58V128.139H208.787V133.348Z"
                            fill="white"
                          />
                          <path
                            d="M202.673 133.348H203.465V128.139H202.673V133.348Z"
                            fill="white"
                          />
                        </g>
                        <path
                          opacity="0.15"
                          d="M241.876 112.665V134.209L265.059 144.686L288 134.005V112.858L265.312 101.586L241.876 112.665Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M265.311 116.712C265.733 116.712 266.07 117.049 266.07 117.47V128.056C266.07 128.477 265.733 128.814 265.311 128.814C264.89 128.814 264.553 128.477 264.553 128.056V117.47C264.553 117.049 264.89 116.712 265.311 116.712Z"
                          fill="white"
                        />
                        <path
                          d="M271.37 122.757C271.37 123.179 271.032 123.516 270.611 123.516H260.025C259.604 123.516 259.267 123.179 259.267 122.757C259.267 122.336 259.604 121.999 260.025 121.999H270.611C271.032 121.999 271.37 122.336 271.37 122.757Z"
                          fill="white"
                        />
                        <path
                          opacity="0.15"
                          d="M61 57.7318V73.536L78.0056 81.2216L94.8345 73.3858V57.8732L78.1911 49.6045L61 57.7318Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M78.1911 60.7002C78.5003 60.7002 78.7477 60.9475 78.7477 61.2567V69.0219C78.7477 69.3311 78.5003 69.5784 78.1911 69.5784C77.8819 69.5784 77.6346 69.3311 77.6346 69.0219V61.2567C77.6346 60.9475 77.8819 60.7002 78.1911 60.7002Z"
                          fill="white"
                        />
                        <path
                          d="M82.635 65.1348C82.635 65.444 82.3877 65.6913 82.0785 65.6913H74.3133C74.0041 65.6913 73.7568 65.444 73.7568 65.1348C73.7568 64.8256 74.0041 64.5782 74.3133 64.5782H82.0785C82.3877 64.5782 82.635 64.8256 82.635 65.1348Z"
                          fill="white"
                        />
                        <path
                          opacity="0.15"
                          d="M185.805 25.8863V33.4434L193.936 37.1185L201.984 33.3716V25.9539L194.025 22L185.805 25.8863Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M194.025 27.3055C194.173 27.3055 194.291 27.4238 194.291 27.5716V31.2847C194.291 31.4326 194.173 31.5509 194.025 31.5509C193.877 31.5509 193.759 31.4326 193.759 31.2847V27.5716C193.759 27.4238 193.877 27.3055 194.025 27.3055Z"
                          fill="white"
                        />
                        <path
                          d="M196.15 29.4261C196.15 29.574 196.032 29.6922 195.884 29.6922H192.171C192.023 29.6922 191.905 29.574 191.905 29.4261C191.905 29.2783 192.023 29.16 192.171 29.16H195.884C196.032 29.16 196.15 29.2783 196.15 29.4261Z"
                          fill="white"
                        />
                        <g clip-path="url(#clip1_1_462)">
                          <path
                            opacity="0.3"
                            d="M87.9059 179C119.334 179 144.812 177.094 144.812 174.742C144.812 172.39 119.334 170.484 87.9059 170.484C56.4777 170.484 31 172.39 31 174.742C31 177.094 56.4777 179 87.9059 179Z"
                            fill="#076048"
                          />
                          <path
                            d="M100.791 92.7567C100.791 92.7567 99.7204 78.6936 101.774 73.5881C103.828 68.4827 104.811 68.3029 105.794 69.1966C106.777 70.0903 110.173 74.4819 110.26 75.2883C110.347 76.0946 110.618 71.3487 112.405 69.1966C114.193 67.0445 115.176 67.7636 116.871 71.6158C118.566 75.468 119.549 80.933 119.549 82.0989C119.549 83.2649 108.027 92.6694 108.027 92.6694L100.791 92.7567Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M106.598 91.3237C106.598 91.3237 104.099 82.9927 104.007 76.8137C103.92 70.6348 104.273 69.6486 105.256 69.9157C106.24 70.1828 109.005 74.035 110.705 77.0808C112.4 80.1266 113.655 83.3522 113.655 83.3522L106.598 91.3237Z"
                            fill="white"
                          />
                          <path
                            d="M114.095 69.0169C114.428 68.4878 116.953 71.0765 118.827 77.4301C119.708 80.4091 119.99 85.2321 119.99 85.2321L113.65 83.3522C113.65 83.3522 113.025 70.7221 114.095 69.022V69.0169Z"
                            fill="white"
                          />
                          <path
                            d="M111.776 76.449C112.825 76.2128 113.471 76.9884 113.471 76.9884L113.65 83.3471L110.7 77.0757C110.7 77.0757 110.966 76.6288 111.77 76.449H111.776Z"
                            fill="#E9803B"
                          />
                          <path
                            d="M86.2313 174.002C86.2313 174.002 108.201 176.154 112.134 164.238C116.062 152.322 113.117 147.217 113.117 147.217L98.4708 151.069L86.2364 174.002H86.2313Z"
                            fill="#7C2F0D"
                          />
                          <path
                            d="M102.127 82.7204C102.127 82.7204 100.161 88.6323 101.057 96.5165C101.948 104.401 103.377 105.474 103.023 108.52C102.67 111.566 101.236 113.718 99.8074 118.197C98.3786 122.676 97.4875 128.048 93.196 131.993C88.9097 135.932 82.836 138.264 74.9751 142.024C67.1141 145.784 99.0905 160.658 99.0905 160.658L104.626 153.673L105.799 154.305C105.799 154.305 109.63 156 111.412 150.987C113.199 145.969 122.13 130.565 122.13 124.293C122.13 118.022 124.45 101.72 124.45 101.72L141.954 97.2407V93.4809C141.954 93.4809 139.988 94.3746 135.343 91.1542C130.698 87.9286 128.02 83.0903 123.733 81.837C119.447 80.5837 115.693 81.6572 112.482 82.3763C109.266 83.0954 106.588 90.7947 106.588 91.334C106.588 91.8733 102.481 85.6019 102.122 82.7358L102.127 82.7204Z"
                            fill="#E86A25"
                          />
                          <path
                            d="M94.1844 167.115C100.381 163.154 102.522 160.525 105.646 158.105C108.349 156.015 113.03 152.944 116.328 151.053C116.84 150.761 117.322 150.494 117.757 150.262C120.973 148.562 120.102 149.405 124.747 146.092C129.392 142.779 131.456 140.411 133.008 138.012C136.546 132.547 136.311 124.653 136.311 124.653L132.178 124.858C132.178 124.858 136.239 120.878 135.973 119.445C135.973 119.445 134.544 119.357 131.953 115.772C129.361 112.187 129.182 107.082 129.182 107.082C129.182 107.082 134.365 105.202 138.293 102.336C142.221 99.4698 142.671 97.7697 142.671 97.7697L142.046 96.0696C142.046 96.0696 135.614 97.8622 127.042 97.4153C118.469 96.9684 111.857 92.5769 111.857 92.5769C111.857 92.5769 112.661 95.7101 114.09 96.876C114.09 96.876 111.32 97.9495 108.462 97.4153C108.462 97.4153 108.728 100.374 112.303 101.447C115.878 102.521 116.41 101.987 116.41 101.987C116.41 101.987 114.802 104.406 112.749 105.032C112.749 105.032 113.732 106.645 117.393 106.733C117.393 106.733 112.569 110.492 111.857 114.17C111.14 117.842 110.787 117.842 112.661 116.949C114.536 116.055 115.878 116.055 115.878 116.055C115.878 116.055 114.807 118.561 114.362 123.133C113.916 127.699 115.345 132.27 114.362 136.836C113.378 141.402 111.95 147.319 111.95 147.319L104.626 153.678L97.8973 163.632C97.8973 163.632 92.1002 168.455 94.1793 167.13L94.1844 167.115Z"
                            fill="white"
                          />
                          <path
                            d="M117.762 150.262C117.762 150.262 118.566 171.403 118.925 173.196C119.283 174.988 120.353 175.076 121.603 175.168C122.853 175.261 124.194 175.435 124.461 175.081C124.727 174.726 124.727 172.662 123.032 171.948C121.337 171.234 123.569 162.451 124.102 158.332C124.64 154.212 125.797 145.881 125.797 145.881L117.757 150.273L117.762 150.262Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M111.955 147.309L111.304 153.678L108.595 159.893L105.031 161.213C105.031 161.213 104.99 157.967 104.632 153.668C104.273 149.369 104.514 136.348 104.514 136.348L111.955 147.309Z"
                            fill="#E86A25"
                          />
                          <path
                            d="M120.799 155.727C124.435 153.514 126.038 145.131 126.038 145.131C126.038 145.131 122.95 147.299 121.967 147.9C120.906 148.547 117.762 150.257 117.762 150.257L118.121 159.184C118.121 159.184 118.3 157.243 120.799 155.717V155.727Z"
                            fill="#140504"
                          />
                          <path
                            d="M87.4809 141.577C87.4809 141.577 93.0168 141.038 96.2329 143.904L99.449 146.77C99.449 146.77 101.861 144.797 101.861 143.637C101.861 142.476 101.595 135.845 102.307 133.873C103.024 131.9 104.626 153.668 104.626 153.668L97.8973 163.622L87.4758 141.577H87.4809Z"
                            fill="#CE5215"
                          />
                          <path
                            d="M111.304 153.678C111.304 153.678 108.918 166.837 109.01 169.611C109.097 172.39 110.705 174.002 110.705 175.256C110.705 176.509 107.31 176.509 106.506 176.149C105.702 175.79 105.256 173.463 105.164 172.39C105.077 171.316 104.949 159.544 104.949 159.544C104.949 159.544 106.383 160.591 108.124 158.681C110.603 155.969 111.299 153.678 111.299 153.678H111.304Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M97.7539 170.956C101.415 171.09 103.915 171.85 103.915 173.915C103.915 175.98 100.519 174.809 96.9499 174.809C93.3804 174.809 81.6377 173.797 81.6377 173.797C81.6377 173.797 92.1258 171.496 93.2831 170.777C94.4456 170.058 92.9247 170.777 97.7488 170.956H97.7539Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M106.864 170.33C106.864 170.33 115.35 170.063 116.866 170.689C118.382 171.316 119.724 173.109 119.012 173.822C118.295 174.542 116.866 174.988 113.655 174.002C110.444 173.016 103.92 173.915 103.92 173.915L102.711 172.323L106.869 170.33H106.864Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M66.5099 154.377C66.5099 154.377 61.2198 158.953 58.0959 156.893C54.972 154.834 54.4343 150.535 58.1829 148.295C61.9316 146.056 68.7222 146.236 68.7222 146.236L86.851 138.084C86.851 138.084 90.1541 131.546 89.4423 127.427C88.7253 123.307 82.9231 116.497 82.9231 116.497L63.4526 123.662C63.4526 123.662 41.6622 130.113 37.0173 141.844C32.3725 153.58 37.9084 163.252 42.8247 165.851C47.7358 168.45 52.0222 169.436 57.384 168.897C62.7407 168.358 65.332 164.151 65.332 164.151C65.332 164.151 65.798 157.695 66.5099 154.382V154.377Z"
                            fill="url(#paint0_linear_1_462)"
                          />
                          <path
                            d="M91.8134 142.363C98.4504 145.368 103.945 162.687 93.913 170.33C84.0907 177.808 70.3354 173.016 66.7608 167.104C63.1863 161.192 63.1863 154.027 66.2231 149.189C69.2599 144.351 78.1605 136.184 91.8083 142.363H91.8134Z"
                            fill="url(#paint1_linear_1_462)"
                          />
                          <path
                            d="M66.7608 136.559C66.7608 136.559 74.5296 139.158 80.8746 136.199C87.2146 133.241 89.0019 130.647 89.4474 127.421C89.8929 124.196 88.7304 115.058 82.1242 111.653C75.5128 108.248 66.94 108.16 66.94 108.16C66.94 108.16 71.4671 110.672 70.023 114.19C69.5979 115.223 66.4023 113.959 65.6854 113.153C65.6854 113.153 67.5648 116.579 66.136 119.265C64.7072 121.951 61.5833 126.163 60.4209 126.877C59.2584 127.596 67.7441 127.771 69.1729 127.144C70.6016 126.517 69.0858 135.475 66.7608 136.549V136.559Z"
                            fill="white"
                          />
                          <path
                            d="M141.965 93.4707C141.965 93.4707 143.035 91.4983 145.268 92.125C147.5 92.7516 144.018 96.9633 142.676 97.7697C141.335 98.5761 141.161 94.1846 141.959 93.4707H141.965Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M121.408 96.5216C122.817 96.5216 123.959 95.3764 123.959 93.9637C123.959 92.5511 122.817 91.4059 121.408 91.4059C120 91.4059 118.858 92.5511 118.858 93.9637C118.858 95.3764 120 96.5216 121.408 96.5216Z"
                            fill="#222222"
                          />
                          <path
                            d="M122.13 93.5683C122.461 93.5683 122.73 93.2992 122.73 92.9673C122.73 92.6354 122.461 92.3664 122.13 92.3664C121.8 92.3664 121.531 92.6354 121.531 92.9673C121.531 93.2992 121.8 93.5683 122.13 93.5683Z"
                            fill="#E9E3DC"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_1_462"
                            x1="45.9178"
                            y1="167.649"
                            x2="77.393"
                            y2="113.29"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#E8521F" />
                            <stop offset="0.59" stop-color="#E86A25" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_1_462"
                            x1="64.0108"
                            y1="157.15"
                            x2="99.4182"
                            y2="157.15"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#E8521F" />
                            <stop offset="0.59" stop-color="#E86A25" />
                          </linearGradient>
                          <clipPath id="clip0_1_462">
                            <rect
                              width="78.1305"
                              height="73.0736"
                              fill="white"
                              transform="translate(153.247 92.5418)"
                            />
                          </clipPath>
                          <clipPath id="clip1_1_462">
                            <rect
                              width="115"
                              height="111"
                              fill="white"
                              transform="translate(31 67.9999)"
                            />
                          </clipPath>
                        </defs>
                      </SuccessImageMobile>
                      <SuccessImage
                        viewBox="0 0 307 310"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.1"
                          d="M19.0563 139.723V197.795L81.4694 226.016L143.204 197.252V140.266L82.1479 109.873L19.0563 139.723Z"
                          fill="#222222"
                        />
                        <path
                          opacity="0.3"
                          d="M122.167 188.214C131.021 188.214 138.198 187.328 138.198 186.235C138.198 185.141 131.021 184.255 122.167 184.255C113.313 184.255 106.135 185.141 106.135 186.235C106.135 187.328 113.313 188.214 122.167 188.214Z"
                          fill="#222222"
                        />
                        <path
                          d="M139.141 152.085C139.141 152.085 139.141 160.994 136.312 163.963C133.483 166.933 127.825 168.913 125.939 167.431C124.053 165.949 122.638 161.986 124.996 159.017C127.354 156.048 131.597 155.057 134.426 154.563C136.203 154.209 137.84 153.348 139.141 152.085Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M104.249 158.519C104.249 158.519 109.436 155.549 113.208 156.045C116.981 156.54 119.809 158.519 120.752 161.983C121.695 165.447 119.684 167.48 117.451 168.417C115.094 169.407 112.265 168.417 110.378 164.458C108.492 160.498 104.249 158.519 104.249 158.519Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M124.053 185.245C124.053 185.245 123.11 187.224 120.752 185.245C120.752 185.245 121.695 178.315 121.695 176.336C121.951 174.509 121.79 172.648 121.223 170.892C120.28 168.418 116.037 164.458 115.094 163.468C114.151 162.479 112.265 160.994 113.21 160.994C114.154 160.994 116.51 161.983 118.868 164.461C121.225 166.939 123.111 169.41 123.111 169.41C123.111 169.41 125.469 164.461 126.88 162.977C128.292 161.493 132.067 157.038 133.481 158.027C134.895 159.017 131.123 160.997 130.18 161.986C129.237 162.976 124.994 169.41 124.523 171.39C124.051 173.369 124.053 185.245 124.053 185.245Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.3"
                          d="M84.5894 155.048C93.4433 155.048 100.621 154.161 100.621 153.068C100.621 151.975 93.4433 151.089 84.5894 151.089C75.7354 151.089 68.5579 151.975 68.5579 153.068C68.5579 154.161 75.7354 155.048 84.5894 155.048Z"
                          fill="#222222"
                        />
                        <path
                          d="M67.6157 118.919C67.6157 118.919 67.6157 127.827 70.4446 130.797C73.2736 133.767 78.9315 135.746 80.8174 134.264C82.7034 132.782 84.1182 128.82 81.7604 125.851C79.4026 122.881 75.1595 121.891 72.3306 121.396C70.5531 121.042 68.9158 120.182 67.6157 118.919Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M102.507 125.352C102.507 125.352 97.3208 122.383 93.5481 122.878C89.7754 123.374 86.9472 125.352 86.0043 128.816C85.0613 132.279 87.0724 134.313 89.3051 135.25C91.6621 136.24 94.4911 135.25 96.3778 131.291C98.2645 127.331 102.507 125.352 102.507 125.352Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M82.7034 152.078C82.7034 152.078 83.6464 154.058 86.0042 152.078C86.0042 152.078 85.0612 145.149 85.0612 143.17C84.8048 141.343 84.9662 139.481 85.5331 137.726C86.4761 135.251 90.7191 131.291 91.6621 130.302C92.6051 129.312 94.491 127.827 93.5465 127.827C92.6021 127.827 90.2465 128.817 87.8887 131.294C85.5308 133.772 83.6449 136.244 83.6449 136.244C83.6449 136.244 81.2878 131.294 79.8759 129.81C78.4641 128.326 74.6892 123.871 73.2751 124.861C71.861 125.851 75.6314 127.827 76.5744 128.816C77.5174 129.805 81.7604 136.24 82.2323 138.219C82.7041 140.199 82.7034 152.078 82.7034 152.078Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.3"
                          d="M47.1482 188.214C56.0022 188.214 63.1797 187.328 63.1797 186.235C63.1797 185.141 56.0022 184.255 47.1482 184.255C38.2943 184.255 31.1168 185.141 31.1168 186.235C31.1168 187.328 38.2943 188.214 47.1482 188.214Z"
                          fill="#222222"
                        />
                        <path
                          d="M59.465 160.88C57.3454 160.711 55.2136 160.781 53.1099 161.091C51.7134 161.259 50.4056 161.864 49.3726 162.819C48.3397 163.774 47.6341 165.03 47.3563 166.409C47.0321 167.498 47.1326 168.669 47.6373 169.687C48.1421 170.704 49.0137 171.493 50.0767 171.894C51.9385 172.694 53.9081 171.743 56.2064 168.904C57.9953 166.572 59.1211 163.799 59.465 160.88Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M32.5724 159.112C32.8695 161.393 33.3857 163.639 34.1138 165.821C35.2038 168.825 37.2639 170.744 40.117 170.802C42.97 170.859 44.1625 168.779 44.4678 166.744C44.7904 164.597 43.5173 162.706 40.4773 160.869C38.0892 159.475 35.3259 158.861 32.5724 159.112Z"
                          fill="#28C07F"
                        />
                        <path
                          d="M45.6543 185.245C45.6543 185.245 46.5226 186.219 48.1719 185.245C48.1719 185.245 47.6201 180.868 47.6201 178.889C47.3637 177.062 47.5248 175.201 48.0912 173.445C48.8969 171.52 50.0953 169.784 51.6099 168.349C52.5529 167.359 54.5097 165.37 53.5697 165.37C52.6298 165.37 51.233 166.299 48.8737 168.774C46.5143 171.249 46.2083 171.96 46.2083 171.96C46.2083 171.96 44.0268 168.982 42.612 167.498C41.1971 166.014 39.2072 163.669 37.5247 163.669C36.7423 163.669 40.1034 167.784 41.0464 168.774C41.9894 169.764 44.3223 171.96 44.7942 173.94C45.2661 175.919 45.6543 185.245 45.6543 185.245Z"
                          fill="#0F9B7B"
                        />
                        <path
                          opacity="0.1"
                          d="M91.1772 36.8024V94.8437L153.59 123.065L215.325 94.3008V37.3148L154.269 6.92241L91.1772 36.8024Z"
                          fill="#222222"
                        />
                        <path
                          opacity="0.078"
                          d="M113.979 83.7028C122.314 83.7028 129.07 82.8557 129.07 81.8108C129.07 80.7658 122.314 79.9188 113.979 79.9188C105.645 79.9188 98.8884 80.7658 98.8884 81.8108C98.8884 82.8557 105.645 83.7028 113.979 83.7028Z"
                          fill="black"
                        />
                        <path
                          d="M115.984 81.5771L113.979 44.2196H112.931L111.982 81.5771C111.982 81.5771 113.158 82.1575 115.984 81.5771Z"
                          fill="white"
                        />
                        <path
                          d="M113.919 44.5287C113.919 44.5287 104.595 58.8506 105.085 60.8406C105.575 62.8306 114.409 49.5788 114.409 49.5788C114.409 49.5788 114.771 45.7498 113.919 44.5287Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M108.861 57.3731L107.037 55.9484C106.462 56.999 105.941 58.0784 105.476 59.1821L106.667 60.0036C107.293 59.3403 108.062 58.4133 108.861 57.3731Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M113.406 43.7749C113.406 43.7749 103.758 29.6566 101.745 29.3551C99.7327 29.0536 108.529 42.2824 108.529 42.2824C108.529 42.2824 111.944 44.1065 113.406 43.7749Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M103.464 34.1643L105.476 33.0336C104.733 32.0953 103.938 31.1993 103.095 30.3501L101.873 31.1039C102.28 31.9707 102.846 33.0336 103.464 34.1643Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M113.941 44.5438C113.941 44.5438 131.037 45.1317 132.469 43.6844C133.901 42.2371 118.019 41.521 118.019 41.521C118.019 41.521 114.544 43.1719 113.941 44.5438Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M127.585 42.2445L127.306 44.5059C128.504 44.4606 129.699 44.3526 130.886 44.182L130.977 42.7348C130.05 42.5689 128.859 42.3802 127.585 42.2445Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M114.303 41.6266H113.301C113.118 41.6206 112.936 41.6507 112.765 41.7153C112.594 41.78 112.437 41.8777 112.304 42.0031C112.171 42.1285 112.064 42.2794 111.989 42.4463C111.914 42.6132 111.873 42.7931 111.868 42.9759V43.33V43.6844L111.77 46.8276L115.539 46.4887L115.645 43.8051V43.4507V43.0966C115.655 42.9116 115.628 42.7264 115.566 42.5519C115.504 42.3774 115.407 42.2169 115.282 42.0801C115.158 41.9432 115.007 41.8325 114.838 41.7547C114.67 41.6768 114.488 41.6333 114.303 41.6266Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M113.723 45.1919C114.297 45.1919 114.763 44.7262 114.763 44.1517C114.763 43.5772 114.297 43.1115 113.723 43.1115C113.148 43.1115 112.682 43.5772 112.682 44.1517C112.682 44.7262 113.148 45.1919 113.723 45.1919Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M195.403 83.7028C203.737 83.7028 210.493 82.8557 210.493 81.8108C210.493 80.7658 203.737 79.9188 195.403 79.9188C187.068 79.9188 180.312 80.7658 180.312 81.8108C180.312 82.8557 187.068 83.7028 195.403 83.7028Z"
                          fill="black"
                        />
                        <path
                          d="M197.4 81.5771L195.395 44.2196H194.355L193.398 81.5771C193.398 81.5771 194.581 82.1575 197.4 81.5771Z"
                          fill="white"
                        />
                        <path
                          d="M195.342 44.5287C195.342 44.5287 186.01 58.8506 186.508 60.8406C187.005 62.8306 195.825 49.5788 195.825 49.5788C195.825 49.5788 196.179 45.7498 195.342 44.5287Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M190.277 57.3731L188.46 55.9484C187.884 56.9991 187.36 58.0784 186.893 59.1821L188.084 60.0036C188.858 59.1641 189.59 58.2862 190.277 57.3731Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M194.83 43.7749C194.83 43.7749 185.181 29.6566 183.161 29.3551C181.141 29.0536 189.945 42.2824 189.945 42.2824C189.945 42.2824 193.367 44.1065 194.83 43.7749Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M184.918 34.1643L186.93 33.0336C186.183 32.0989 185.388 31.2032 184.548 30.3501L183.327 31.1039C183.804 32.1509 184.335 33.1724 184.918 34.1643Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M195.365 44.5438C195.365 44.5438 212.453 45.1317 213.893 43.6844C215.333 42.2371 199.435 41.521 199.435 41.521C199.435 41.521 195.968 43.1719 195.365 44.5438Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M208.993 42.2445L208.714 44.5059C209.91 44.4606 211.103 44.3526 212.287 44.182L212.378 42.7348C211.466 42.5689 210.275 42.3802 208.993 42.2445Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M195.719 41.6266H194.724C194.541 41.6206 194.359 41.6508 194.187 41.7153C194.016 41.7799 193.858 41.8775 193.725 42.0028C193.591 42.1281 193.483 42.2786 193.408 42.4455C193.332 42.6125 193.29 42.7928 193.285 42.9759V43.33V43.6844L193.187 46.8276L196.956 46.4887L197.069 43.8051V43.0966C197.079 42.911 197.052 42.7251 196.989 42.5501C196.926 42.3751 196.829 42.2144 196.703 42.0775C196.578 41.9405 196.426 41.8299 196.257 41.7525C196.088 41.6751 195.905 41.6324 195.719 41.6266Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M195.146 45.1919C195.721 45.1919 196.187 44.7262 196.187 44.1517C196.187 43.5772 195.721 43.1115 195.146 43.1115C194.572 43.1115 194.106 43.5772 194.106 44.1517C194.106 44.7262 194.572 45.1919 195.146 45.1919Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M130.366 38.0763C135.774 38.0763 140.158 37.5262 140.158 36.8476C140.158 36.169 135.774 35.619 130.366 35.619C124.959 35.619 120.575 36.169 120.575 36.8476C120.575 37.5262 124.959 38.0763 130.366 38.0763Z"
                          fill="black"
                        />
                        <path
                          d="M131.663 36.6743L130.359 12.4326H129.68L129.062 36.6743C129.062 36.6743 129.846 37.104 131.663 36.6743Z"
                          fill="white"
                        />
                        <path
                          d="M130.306 12.1462C130.306 12.1462 139.193 18.7869 140.497 18.5457C141.801 18.3045 133.593 12.0406 133.593 12.0406C133.593 12.0406 131.128 11.6412 130.306 12.1462Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M138.409 15.998L137.414 17.1213C138.168 17.5962 138.884 18.0029 139.434 18.2667L140.022 17.5129C139.645 17.0531 139.042 16.5256 138.409 15.998Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M129.793 12.4478C129.793 12.4478 120.243 18.1011 119.994 19.3901C119.746 20.6791 128.655 15.5233 128.655 15.5233C128.655 15.5233 129.944 13.4051 129.793 12.4478Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M123.16 18.4629L122.504 17.1136C121.867 17.5557 121.253 18.0313 120.665 18.5383L121.125 19.3598C121.683 19.1563 122.391 18.8322 123.16 18.4629Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M130.314 12.1313C130.314 12.1313 131.414 1.0884 130.54 0.0707963C129.665 -0.94681 128.527 9.34217 128.527 9.34217C128.527 9.34217 129.454 11.6866 130.314 12.1313Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M129.394 3.22128L130.901 3.49291C130.923 2.71599 130.903 1.93822 130.841 1.16347L129.906 1.05048C129.71 1.61581 129.552 2.38458 129.394 3.22128Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M130.6 10.7741H129.952C129.712 10.7679 129.48 10.8563 129.305 11.0199C129.13 11.1835 129.027 11.4093 129.017 11.6486V12.1083L128.949 14.1436L131.399 13.925L131.474 12.1837V11.724C131.48 11.604 131.462 11.4837 131.422 11.3707C131.381 11.2577 131.318 11.154 131.236 11.0656C131.155 10.9771 131.057 10.9058 130.948 10.8558C130.838 10.8057 130.72 10.7779 130.6 10.7741Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M130.193 13.0885C130.568 13.0885 130.871 12.7848 130.871 12.4101C130.871 12.0354 130.568 11.7317 130.193 11.7317C129.818 11.7317 129.514 12.0354 129.514 12.4101C129.514 12.7848 129.818 13.0885 130.193 13.0885Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M173.875 38.3401C179.283 38.3401 183.666 37.79 183.666 37.1114C183.666 36.4329 179.283 35.8828 173.875 35.8828C168.467 35.8828 164.083 36.4329 164.083 37.1114C164.083 37.79 168.467 38.3401 173.875 38.3401Z"
                          fill="black"
                        />
                        <path
                          d="M175.171 36.9307L173.867 12.6966H173.196L172.578 36.9307C172.578 36.9307 173.339 37.3377 175.171 36.9307Z"
                          fill="white"
                        />
                        <path
                          d="M173.852 13.0959C173.852 13.0959 169.043 23.0985 169.525 24.3272C170.008 25.5558 174.583 16.2995 174.583 16.2995C174.583 16.2995 174.508 13.812 173.852 13.0959Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M171.666 21.7796L170.377 21.0258C170.086 21.7478 169.834 22.4852 169.623 23.2345L170.46 23.664C170.822 23.1816 171.236 22.5183 171.666 21.7796Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M173.46 12.6513C173.46 12.6513 166.073 4.35971 164.754 4.35971C163.435 4.35971 170.211 12.1162 170.211 12.1162C170.211 12.1162 172.548 12.983 173.46 12.6513Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M166.276 7.29928L167.482 6.40232C166.925 5.86806 166.339 5.36478 165.726 4.89476L164.972 5.49764C165.312 5.98006 165.764 6.62088 166.276 7.29928Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M173.867 13.1036C173.867 13.1036 184.918 12.0557 185.717 11.0079C186.516 9.96015 176.234 10.8195 176.234 10.8195C176.234 10.8195 174.138 12.1689 173.867 13.1036Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M182.438 10.4879V11.9954C183.2 11.8648 183.955 11.6936 184.699 11.4827L184.639 10.5482C183.906 10.4918 183.172 10.4716 182.438 10.4879Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M174.086 11.038H173.43C173.311 11.035 173.193 11.0557 173.082 11.0984C172.971 11.1411 172.87 11.2049 172.784 11.2868C172.697 11.3687 172.628 11.4667 172.58 11.5754C172.532 11.684 172.506 11.8011 172.503 11.9199V12.3799L172.435 14.4149L174.892 14.1963L174.96 12.455V11.9953C174.967 11.8747 174.95 11.7537 174.91 11.6398C174.869 11.5258 174.806 11.4213 174.725 11.3321C174.643 11.2428 174.545 11.1709 174.435 11.1204C174.325 11.0699 174.206 11.0418 174.086 11.038Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M173.709 13.3522C174.083 13.3522 174.387 13.0485 174.387 12.6738C174.387 12.2991 174.083 11.9954 173.709 11.9954C173.334 11.9954 173.03 12.2991 173.03 12.6738C173.03 13.0485 173.334 13.3522 173.709 13.3522Z"
                          fill="white"
                        />
                        <path
                          opacity="0.078"
                          d="M151.261 104.175C163.729 104.175 173.837 103.328 173.837 102.283C173.837 101.239 163.729 100.391 151.261 100.391C138.793 100.391 128.685 101.239 128.685 102.283C128.685 103.328 138.793 104.175 151.261 104.175Z"
                          fill="black"
                        />
                        <path
                          d="M154.932 101.884L151.992 47.0989H150.485L149.083 101.884C149.083 101.884 150.794 102.796 154.932 101.884Z"
                          fill="white"
                        />
                        <path
                          d="M151.864 46.4432C151.864 46.4432 171.96 61.4583 174.9 60.9156C177.839 60.3729 159.304 46.2095 159.304 46.2095C159.304 46.2095 153.733 45.2975 151.864 46.4432Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M170.181 55.0665L167.92 57.5991C169.4 58.5442 170.93 59.4097 172.503 60.1921L173.822 58.5263C172.917 57.5388 171.628 56.3329 170.181 55.0665Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M150.718 47.1216C150.718 47.1216 129.13 59.8983 128.497 62.823C127.864 65.7477 148.095 54.079 148.095 54.079C148.095 54.079 151.058 49.2925 150.718 47.1216Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M135.711 60.7199L134.203 57.6668C132.762 58.67 131.373 59.747 130.042 60.8932L131.075 62.7549C132.379 62.2875 133.985 61.5566 135.711 60.7199Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M151.887 46.4131C151.887 46.4131 154.367 21.4476 152.392 19.2089C150.417 16.9701 147.869 40.1565 147.869 40.1565C147.869 40.1565 149.935 45.3955 151.887 46.4131Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M149.814 26.2647L153.146 26.8904C153.19 25.1304 153.144 23.3693 153.01 21.6139L150.899 21.3423C150.523 22.6463 150.198 24.3727 149.814 26.2647Z"
                          fill="#FFA200"
                        />
                        <path
                          d="M152.46 43.3449L150.997 43.3C150.455 43.2837 149.928 43.483 149.532 43.8546C149.137 44.2263 148.905 44.7398 148.887 45.2823V45.8024V46.3225L148.744 50.928L154.284 50.4307L154.442 46.4958V45.9757V45.4557C154.458 44.9131 154.259 44.3861 153.887 43.9904C153.516 43.5948 153.002 43.3626 152.46 43.3449Z"
                          fill="#CCCCCC"
                        />
                        <path
                          d="M151.623 48.5765C152.468 48.5765 153.153 47.8914 153.153 47.0463C153.153 46.2012 152.468 45.5161 151.623 45.5161C150.778 45.5161 150.093 46.2012 150.093 47.0463C150.093 47.8914 150.778 48.5765 151.623 48.5765Z"
                          fill="white"
                        />
                        <g clip-path="url(#clip0_1_244)">
                          <path
                            opacity="0.1"
                            d="M162.275 139.723V197.764L224.688 225.986L286.423 197.222V140.266L225.366 109.873L162.275 139.723Z"
                            fill="#222222"
                          />
                          <path
                            opacity="0.078"
                            d="M228.826 179.613C228.826 180.985 216.932 183.216 202.263 183.216C187.594 183.216 175.7 180.955 175.7 179.613C175.7 178.272 187.587 177.126 202.263 177.126C216.939 177.126 228.826 178.264 228.826 179.613Z"
                            fill="black"
                          />
                          <path
                            opacity="0.078"
                            d="M265.897 179.613C265.897 180.985 257.138 183.216 246.299 183.216C235.46 183.216 226.701 180.955 226.701 179.613C226.701 178.272 235.46 177.126 246.299 177.126C257.138 177.126 265.897 178.264 265.897 179.613Z"
                            fill="black"
                          />
                          <path
                            d="M232.889 196.393L231.133 192.495L233.62 194.448L234.269 189.963L235.475 194.011L236.982 190.355L237.374 193.913L240.005 191.425L237.857 196.393H232.889Z"
                            fill="#04513E"
                          />
                          <path
                            d="M220.904 213.3L219.148 209.403L221.635 211.348L222.284 206.87L223.482 210.91L224.99 207.255L225.382 210.812L228.012 208.332L225.864 213.3H220.904Z"
                            fill="#04513E"
                          />
                          <path
                            d="M255.329 204.111L253.573 200.214L256.06 202.159L256.709 197.681L257.907 201.722L259.415 198.066L259.799 201.624L262.43 199.136L260.289 204.111H255.329Z"
                            fill="#04513E"
                          />
                          <path
                            d="M269.297 165.797L267.548 161.899L270.028 163.844L270.684 159.367L271.882 163.407L273.39 159.751L273.782 163.309L276.413 160.829L274.272 165.797H269.297Z"
                            fill="#04513E"
                          />
                          <path
                            d="M268.362 143.515L266.606 139.618L269.093 141.57L269.742 137.085L270.94 141.133L272.448 137.477L272.84 141.035L275.47 138.547L273.322 143.515H268.362Z"
                            fill="#04513E"
                          />
                          <path
                            d="M187.406 145.166L185.65 141.268L188.137 143.221L188.785 138.736L189.984 142.784L191.491 139.128L191.876 142.686L194.507 140.198L192.366 145.166H187.406Z"
                            fill="#04513E"
                          />
                          <path
                            d="M243.714 133.286L241.965 129.389L244.445 131.334L245.1 126.849L246.299 130.896L247.807 127.241L248.199 130.798L250.829 128.311L248.688 133.286H243.714Z"
                            fill="#04513E"
                          />
                          <path
                            d="M214.489 126.849L212.733 122.959L215.221 124.904L215.869 120.419L217.067 124.467L218.575 120.811L218.967 124.369L221.598 121.881L219.449 126.849H214.489Z"
                            fill="#04513E"
                          />
                          <path
                            d="M215.552 148.414L213.803 144.517L216.283 146.462L216.939 141.985L218.138 146.025L219.645 142.376L220.037 145.927L222.668 143.447L220.527 148.414H215.552Z"
                            fill="#04513E"
                          />
                          <path
                            d="M169.933 162.578L168.177 158.681L170.664 160.633L171.313 156.148L172.511 160.196L174.019 156.54L174.403 160.098L177.034 157.61L174.893 162.578H169.933Z"
                            fill="#04513E"
                          />
                          <path
                            d="M204.057 197.448L202.308 193.551L204.788 195.496L205.444 191.018L206.643 195.058L208.15 191.41L208.542 194.96L211.173 192.48L209.032 197.448H204.057Z"
                            fill="#04513E"
                          />
                          <path
                            d="M173.024 196.393L171.268 192.495L173.747 194.448L174.403 189.963L175.602 194.011L177.109 190.355L177.501 193.913L180.132 191.425L177.991 196.393H173.024Z"
                            fill="#04513E"
                          />
                          <path
                            d="M187.097 170.952V171.555C184.836 171.555 183.124 172.98 183.124 174.978V179.764H182.559V174.706C182.537 174.205 182.619 173.704 182.8 173.236C183.074 172.532 183.562 171.932 184.194 171.519C184.827 171.107 185.573 170.903 186.328 170.937L187.097 170.952Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M187.097 171.555V172.249H186.343C185.691 172.251 185.067 172.51 184.605 172.97C184.144 173.431 183.882 174.054 183.878 174.706V179.764H183.125V174.978C183.14 172.98 184.361 171.555 187.097 171.555Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M187.504 168.073V168.872C185.243 168.872 179.325 168.751 179.325 173.395V179.741H178.76V173.033C178.76 168.729 184.398 168.05 186.728 168.05L187.504 168.073Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M187.504 168.872V169.46H186.75C185.393 169.46 180.079 169.46 180.079 173.055V179.764H179.325V173.417C179.295 168.947 184.738 168.872 187.504 168.872Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M182.635 174.096C182.883 174 183.153 173.979 183.413 174.036C183.673 174.092 183.91 174.223 184.097 174.412C184.226 174.539 184.329 174.69 184.399 174.857C184.469 175.024 184.504 175.204 184.504 175.385C184.504 175.566 184.467 175.745 184.398 175.911C184.328 176.078 184.226 176.23 184.097 176.357C183.97 176.486 183.819 176.589 183.652 176.659C183.485 176.729 183.306 176.764 183.124 176.764C182.803 176.764 182.491 176.652 182.243 176.447C181.996 176.239 181.828 175.951 181.768 175.633C181.709 175.318 181.766 174.992 181.926 174.714C182.083 174.432 182.334 174.213 182.635 174.096Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M182.635 174.096C182.825 174.027 183.028 173.998 183.23 174.013C183.434 174.03 183.632 174.092 183.811 174.194H183.599C183.432 174.194 183.266 174.224 183.109 174.284C182.848 174.388 182.623 174.566 182.461 174.797C182.307 175.018 182.223 175.281 182.22 175.55C182.22 175.792 182.285 176.03 182.406 176.239C182.528 176.449 182.703 176.622 182.913 176.741C182.624 176.694 182.358 176.551 182.16 176.334C181.948 176.115 181.815 175.832 181.783 175.529C181.75 175.226 181.819 174.92 181.979 174.661C182.143 174.403 182.386 174.204 182.672 174.096H182.635Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M178.971 174.096C179.13 174.035 179.299 174.005 179.469 174.005C179.833 174.012 180.181 174.157 180.441 174.412C180.696 174.672 180.839 175.021 180.841 175.385C180.842 175.73 180.715 176.063 180.484 176.318C180.252 176.574 179.933 176.734 179.59 176.766C179.246 176.798 178.903 176.7 178.628 176.492C178.354 176.284 178.166 175.98 178.104 175.641C178.044 175.323 178.098 174.993 178.257 174.711C178.415 174.428 178.668 174.21 178.971 174.096Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M178.971 174.096C179.163 174.022 179.369 173.993 179.574 174.01C179.779 174.027 179.977 174.09 180.155 174.194H179.944C179.774 174.193 179.605 174.224 179.446 174.284C179.187 174.388 178.964 174.567 178.805 174.797C178.651 175.018 178.567 175.281 178.564 175.55C178.561 175.792 178.622 176.031 178.743 176.24C178.864 176.45 179.039 176.623 179.25 176.741C178.953 176.691 178.681 176.545 178.474 176.326C178.268 176.107 178.138 175.827 178.104 175.528C178.067 175.228 178.133 174.925 178.293 174.669C178.45 174.409 178.689 174.208 178.971 174.096Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M197.997 155.53H191.28V163.565H197.997V155.53Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M207.668 155.53H200.951V163.565H207.668V155.53Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M210.615 157.837H207.668V158.764H210.615V157.837Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M210.615 158.621H207.668V158.907H210.615V158.621Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M210.615 160.739H207.668V161.666H210.615V160.739Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M210.615 161.523H207.668V161.809H210.615V161.523Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M200.944 157.837H197.997V158.764H200.944V157.837Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M200.944 158.621H197.997V158.907H200.944V158.621Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M200.944 160.739H197.997V161.666H200.944V160.739Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M200.944 161.523H197.997V161.809H200.944V161.523Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M220.557 163.897V164.417H221.311C221.381 162.972 222.002 161.61 223.047 160.61C224.092 159.61 225.48 159.049 226.927 159.043H231.14V158.289H226.181C224.692 158.289 223.264 158.879 222.21 159.931C221.156 160.982 220.561 162.408 220.557 163.897Z"
                            fill="#FADC86"
                          />
                          <path
                            d="M222.495 164.417V163.897C222.497 162.92 222.886 161.984 223.576 161.293C224.267 160.602 225.204 160.213 226.181 160.211H231.14V159.043H226.927C225.48 159.049 224.092 159.61 223.047 160.61C222.002 161.61 221.381 162.972 221.311 164.417H222.495Z"
                            fill="#F5B90D"
                          />
                          <path
                            d="M261.925 149.854H230.869V179.809H261.925V149.854Z"
                            fill="white"
                          />
                          <path
                            d="M223.588 165.186H186.358V179.802H223.588V165.186Z"
                            fill="white"
                          />
                          <path
                            d="M263.289 148.233H229.497V149.846H263.289V148.233Z"
                            fill="#78716C"
                          />
                          <path
                            d="M263.289 149.854H229.497V150.276H263.289V149.854Z"
                            fill="#6D6764"
                          />
                          <path
                            d="M230.869 179.802H261.925V178.106H230.869V179.802Z"
                            fill="white"
                          />
                          <path
                            d="M214.497 179.802H223.588V178.106H214.497V179.802Z"
                            fill="white"
                          />
                          <path
                            d="M200.107 179.802H206.748V178.106H200.107V179.802Z"
                            fill="white"
                          />
                          <path
                            d="M186.358 179.802H192.449V178.106H186.358V179.802Z"
                            fill="white"
                          />
                          <path
                            opacity="0.12"
                            d="M230.869 151.113H261.925V150.276H230.869V151.113Z"
                            fill="black"
                          />
                          <path
                            opacity="0.12"
                            d="M186.358 166.437H223.588V165.601H186.358V166.437Z"
                            fill="black"
                          />
                          <path
                            d="M192.682 170.229H200.168V179.787H192.705L192.682 170.229Z"
                            fill="#847E7B"
                          />
                          <path
                            d="M196.323 179.787H196.693V170.229H196.323V179.787Z"
                            fill="#77716E"
                          />
                          <path
                            d="M206.974 170.229H214.467V179.787H207.004L206.974 170.229Z"
                            fill="#847E7B"
                          />
                          <path
                            d="M210.615 179.787H210.984V170.229H210.615V179.787Z"
                            fill="#77716E"
                          />
                          <path
                            d="M217.165 155.53H210.449V163.565H217.165V155.53Z"
                            fill="#E5E5E5"
                          />
                          <path
                            d="M224.04 163.565H185.439V165.246H224.04V163.565Z"
                            fill="#78716C"
                          />
                          <path
                            d="M224.04 165.186H185.439V165.638H224.04V165.186Z"
                            fill="#6D6764"
                          />
                          <path
                            d="M277.958 181.513H256.452C255.337 176.862 259.724 179.184 259.724 179.184C259.724 179.184 258.073 174.299 259.769 174.804C261.465 175.309 262.121 179.101 262.121 179.101C262.121 179.101 263.003 172.882 264.94 172.475C266.191 172.211 265.204 178.392 265.204 178.392C265.716 177.974 266.352 177.735 267.013 177.714C267.91 177.714 267.691 178.905 267.691 178.905C267.691 178.905 269.561 174.895 270.533 174.947C271.754 175.008 270.443 179.221 270.443 179.221C270.443 179.221 272.847 176.485 273.797 176.553C275.109 176.659 272.817 180.571 272.817 180.571C273.971 179.898 275.297 179.578 276.631 179.651C278.116 179.779 278.712 180.412 277.958 181.513Z"
                            fill="#00A273"
                          />
                          <path
                            d="M220.904 182.169L219.148 178.272L221.635 180.224L222.284 175.739L223.482 179.787L224.99 176.131L225.382 179.689L228.012 177.201L225.864 182.169H220.904Z"
                            fill="#04513E"
                          />
                          <path
                            d="M246.299 163.407C248.943 163.407 251.086 161.264 251.086 158.621C251.086 155.977 248.943 153.834 246.299 153.834C243.656 153.834 241.513 155.977 241.513 158.621C241.513 161.264 243.656 163.407 246.299 163.407Z"
                            fill="#F2F2F2"
                          />
                          <path
                            d="M248.342 154.814L243.48 158.409L245.93 159.08L244.219 162.427L248.749 158.545L246.269 157.995L248.342 154.814Z"
                            fill="#FBB03B"
                          />
                          <path
                            d="M259.89 167.251H233.025V173.643H259.89V167.251Z"
                            fill="#94C4D3"
                          />
                          <path
                            d="M259.89 167.297H233.025V168.156H259.89V167.297Z"
                            fill="#6799A5"
                          />
                          <path
                            d="M250.528 174.714H251.787V166.437H250.528V174.714Z"
                            fill="white"
                          />
                          <path
                            d="M240.811 174.714H242.07V166.437H240.811V174.714Z"
                            fill="white"
                          />
                        </g>
                        <path
                          opacity="0.15"
                          d="M233.952 64.9697V91.1947L262.171 103.948L290.096 90.9455V65.2042L262.479 51.4834L233.952 64.9697Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M262.479 69.8952C262.992 69.8952 263.402 70.3057 263.402 70.8188V83.7041C263.402 84.2171 262.992 84.6275 262.479 84.6275C261.966 84.6275 261.555 84.2171 261.555 83.7041V70.8188C261.555 70.3057 261.966 69.8952 262.479 69.8952Z"
                          fill="white"
                        />
                        <path
                          d="M269.853 77.2542C269.853 77.7673 269.442 78.1777 268.929 78.1777H256.044C255.531 78.1777 255.121 77.7673 255.121 77.2542C255.121 76.7411 255.531 76.3307 256.044 76.3307H268.929C269.442 76.3307 269.853 76.7411 269.853 77.2542Z"
                          fill="white"
                        />
                        <path
                          opacity="0.15"
                          d="M133.361 224.011V241.841L152.546 250.512L171.533 241.672V224.17L152.756 214.842L133.361 224.011Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M152.756 227.36C153.105 227.36 153.384 227.639 153.384 227.988V236.748C153.384 237.097 153.105 237.376 152.756 237.376C152.407 237.376 152.128 237.097 152.128 236.748V227.988C152.128 227.639 152.407 227.36 152.756 227.36Z"
                          fill="white"
                        />
                        <path
                          d="M157.769 232.363C157.769 232.712 157.49 232.991 157.141 232.991H148.381C148.032 232.991 147.753 232.712 147.753 232.363C147.753 232.014 148.032 231.735 148.381 231.735H157.141C157.49 231.735 157.769 232.014 157.769 232.363Z"
                          fill="white"
                        />
                        <path
                          opacity="0.15"
                          d="M0.924072 59.8285V93.6672L37.3352 110.123L73.3681 93.3456V60.1311L37.7324 42.4268L0.924072 59.8285Z"
                          stroke="black"
                          stroke-width="1.26"
                          stroke-linecap="round"
                          stroke-dasharray="2.52 2.52"
                        />
                        <path
                          d="M37.7324 66.184C38.3945 66.184 38.9241 66.7136 38.9241 67.3756V84.0018C38.9241 84.6639 38.3945 85.1934 37.7324 85.1934C37.0704 85.1934 36.5408 84.6639 36.5408 84.0018V67.3756C36.5408 66.7136 37.0704 66.184 37.7324 66.184Z"
                          fill="white"
                        />
                        <path
                          d="M47.2474 75.6793C47.2474 76.3413 46.7178 76.871 46.0558 76.871H29.4296C28.7676 76.871 28.238 76.3413 28.238 75.6793C28.238 75.0173 28.7676 74.4877 29.4296 74.4877H46.0558C46.7178 74.4877 47.2474 75.0173 47.2474 75.6793Z"
                          fill="white"
                        />
                        <g clip-path="url(#clip1_1_244)">
                          <path
                            opacity="0.3"
                            d="M238.298 310C275.465 310 305.595 307.75 305.595 304.975C305.595 302.199 275.465 299.95 238.298 299.95C201.13 299.95 171 302.199 171 304.975C171 307.75 201.13 310 238.298 310Z"
                            fill="#076048"
                          />
                          <path
                            d="M253.535 208.218C253.535 208.218 252.269 191.621 254.698 185.595C257.127 179.57 258.289 179.358 259.452 180.412C260.615 181.467 264.63 186.65 264.733 187.602C264.836 188.553 265.157 182.952 267.271 180.412C269.384 177.873 270.547 178.721 272.552 183.267C274.556 187.814 275.719 194.263 275.719 195.639C275.719 197.015 262.093 208.114 262.093 208.114L253.535 208.218Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M260.403 206.526C260.403 206.526 257.447 196.694 257.338 189.402C257.236 182.11 257.653 180.946 258.816 181.261C259.979 181.576 263.249 186.123 265.26 189.717C267.265 193.312 268.749 197.118 268.749 197.118L260.403 206.526Z"
                            fill="white"
                          />
                          <path
                            d="M269.269 180.2C269.663 179.576 272.649 182.631 274.865 190.129C275.907 193.645 276.24 199.337 276.24 199.337L268.742 197.118C268.742 197.118 268.004 182.213 269.269 180.206V180.2Z"
                            fill="white"
                          />
                          <path
                            d="M266.526 188.972C267.767 188.693 268.53 189.608 268.53 189.608L268.742 197.112L265.254 189.711C265.254 189.711 265.569 189.184 266.52 188.972H266.526Z"
                            fill="#E9803B"
                          />
                          <path
                            d="M236.317 304.102C236.317 304.102 262.299 306.642 266.95 292.579C271.595 278.515 268.113 272.49 268.113 272.49L250.792 277.036L236.323 304.102H236.317Z"
                            fill="#7C2F0D"
                          />
                          <path
                            d="M255.116 196.373C255.116 196.373 252.79 203.35 253.85 212.655C254.904 221.959 256.594 223.226 256.176 226.821C255.758 230.416 254.062 232.955 252.372 238.241C250.683 243.527 249.629 249.868 244.554 254.523C239.485 259.172 232.302 261.924 223.005 266.362C213.709 270.799 251.524 288.354 251.524 288.354L258.071 280.11L259.458 280.855C259.458 280.855 263.988 282.856 266.096 276.939C268.21 271.017 278.772 252.838 278.772 245.437C278.772 238.035 281.515 218.795 281.515 218.795L302.216 213.509V209.072C302.216 209.072 299.89 210.127 294.397 206.326C288.904 202.519 285.736 196.809 280.667 195.33C275.598 193.851 271.159 195.118 267.362 195.967C263.558 196.815 260.391 205.902 260.391 206.538C260.391 207.175 255.534 199.774 255.11 196.391L255.116 196.373Z"
                            fill="#E86A25"
                          />
                          <path
                            d="M245.723 295.973C253.051 291.3 255.582 288.196 259.276 285.341C262.474 282.874 268.01 279.249 271.91 277.018C272.516 276.673 273.085 276.357 273.6 276.085C277.403 274.078 276.373 275.072 281.866 271.163C287.359 267.253 289.8 264.458 291.635 261.627C295.82 255.178 295.542 245.861 295.542 245.861L290.654 246.103C290.654 246.103 295.457 241.405 295.142 239.714C295.142 239.714 293.452 239.611 290.388 235.38C287.323 231.149 287.111 225.124 287.111 225.124C287.111 225.124 293.24 222.905 297.885 219.523C302.53 216.14 303.063 214.134 303.063 214.134L302.325 212.127C302.325 212.127 294.718 214.243 284.58 213.716C274.441 213.188 266.623 208.005 266.623 208.005C266.623 208.005 267.574 211.703 269.263 213.079C269.263 213.079 265.987 214.346 262.607 213.716C262.607 213.716 262.922 217.207 267.15 218.474C271.377 219.741 272.007 219.11 272.007 219.11C272.007 219.11 270.105 221.966 267.677 222.705C267.677 222.705 268.839 224.608 273.17 224.711C273.17 224.711 267.465 229.149 266.623 233.489C265.775 237.823 265.357 237.823 267.574 236.768C269.79 235.714 271.377 235.714 271.377 235.714C271.377 235.714 270.111 238.672 269.584 244.067C269.057 249.455 270.747 254.85 269.584 260.239C268.421 265.628 266.732 272.611 266.732 272.611L258.071 280.116L250.113 291.863C250.113 291.863 243.258 297.555 245.716 295.991L245.723 295.973Z"
                            fill="white"
                          />
                          <path
                            d="M273.606 276.085C273.606 276.085 274.557 301.035 274.98 303.15C275.404 305.266 276.67 305.369 278.148 305.478C279.626 305.587 281.212 305.793 281.527 305.375C281.842 304.957 281.842 302.52 279.838 301.677C277.833 300.835 280.473 290.469 281.103 285.608C281.739 280.746 283.108 270.914 283.108 270.914L273.6 276.097L273.606 276.085Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M266.738 272.599L265.969 280.116L262.765 287.45L258.55 289.008C258.55 289.008 258.501 285.177 258.077 280.104C257.653 275.03 257.938 259.663 257.938 259.663L266.738 272.599Z"
                            fill="#E86A25"
                          />
                          <path
                            d="M277.197 282.534C281.497 279.922 283.393 270.029 283.393 270.029C283.393 270.029 279.741 272.587 278.578 273.296C277.324 274.06 273.606 276.079 273.606 276.079L274.03 286.614C274.03 286.614 274.242 284.323 277.197 282.522V282.534Z"
                            fill="#140504"
                          />
                          <path
                            d="M237.795 265.834C237.795 265.834 244.342 265.198 248.145 268.58L251.948 271.963C251.948 271.963 254.801 269.635 254.801 268.265C254.801 266.895 254.486 259.069 255.328 256.742C256.176 254.414 258.071 280.104 258.071 280.104L250.113 291.851L237.789 265.834H237.795Z"
                            fill="#CE5215"
                          />
                          <path
                            d="M265.969 280.116C265.969 280.116 263.146 295.646 263.255 298.919C263.358 302.199 265.26 304.102 265.26 305.581C265.26 307.06 261.245 307.06 260.294 306.636C259.343 306.211 258.816 303.465 258.707 302.199C258.604 300.932 258.453 287.038 258.453 287.038C258.453 287.038 260.149 288.275 262.208 286.02C265.139 282.819 265.963 280.116 265.963 280.116H265.969Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M249.944 300.507C254.274 300.665 257.229 301.562 257.229 303.999C257.229 306.436 253.214 305.054 248.993 305.054C244.772 305.054 230.885 303.859 230.885 303.859C230.885 303.859 243.288 301.144 244.657 300.295C246.031 299.447 244.233 300.295 249.938 300.507H249.944Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M260.718 299.768C260.718 299.768 270.753 299.453 272.546 300.192C274.338 300.932 275.925 303.047 275.083 303.89C274.235 304.738 272.546 305.266 268.748 304.102C264.951 302.938 257.235 303.999 257.235 303.999L255.806 302.12L260.724 299.768H260.718Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M212.994 280.94C212.994 280.94 206.738 286.341 203.044 283.91C199.35 281.48 198.714 276.406 203.147 273.763C207.58 271.12 215.611 271.332 215.611 271.332L237.05 261.712C237.05 261.712 240.956 253.996 240.114 249.134C239.267 244.273 232.405 236.235 232.405 236.235L209.379 244.691C209.379 244.691 183.609 252.304 178.116 266.149C172.623 280.001 179.17 291.415 184.984 294.482C190.792 297.549 195.861 298.713 202.202 298.077C208.537 297.44 211.601 292.476 211.601 292.476C211.601 292.476 212.153 284.856 212.994 280.946V280.94Z"
                            fill="url(#paint0_linear_1_244)"
                          />
                          <path
                            d="M242.918 266.762C250.767 270.308 257.266 290.748 245.402 299.768C233.786 308.594 217.518 302.938 213.291 295.961C209.064 288.984 209.064 280.528 212.655 274.818C216.247 269.108 226.772 259.469 242.912 266.762H242.918Z"
                            fill="url(#paint1_linear_1_244)"
                          />
                          <path
                            d="M213.291 259.912C213.291 259.912 222.478 262.979 229.982 259.488C237.48 255.996 239.594 252.935 240.12 249.128C240.647 245.321 239.273 234.538 231.46 230.519C223.641 226.5 213.503 226.397 213.503 226.397C213.503 226.397 218.857 229.361 217.149 233.513C216.646 234.732 212.867 233.24 212.019 232.289C212.019 232.289 214.242 236.332 212.552 239.502C210.863 242.672 207.168 247.643 205.793 248.486C204.419 249.334 214.454 249.54 216.144 248.801C217.833 248.061 216.041 258.633 213.291 259.9V259.912Z"
                            fill="white"
                          />
                          <path
                            d="M302.228 209.06C302.228 209.06 303.493 206.732 306.134 207.472C308.775 208.211 304.656 213.182 303.07 214.134C301.483 215.085 301.277 209.903 302.222 209.06H302.228Z"
                            fill="#3D140E"
                          />
                          <path
                            d="M277.918 212.661C279.583 212.661 280.934 211.309 280.934 209.642C280.934 207.975 279.583 206.623 277.918 206.623C276.252 206.623 274.902 207.975 274.902 209.642C274.902 211.309 276.252 212.661 277.918 212.661Z"
                            fill="#222222"
                          />
                          <path
                            d="M278.772 209.175C279.163 209.175 279.48 208.858 279.48 208.466C279.48 208.074 279.163 207.757 278.772 207.757C278.38 207.757 278.063 208.074 278.063 208.466C278.063 208.858 278.38 209.175 278.772 209.175Z"
                            fill="#E9E3DC"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_1_244"
                            x1="188.642"
                            y1="296.604"
                            x2="225.75"
                            y2="232.384"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#E8521F" />
                            <stop offset="0.59" stop-color="#E86A25" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_1_244"
                            x1="210.039"
                            y1="284.213"
                            x2="251.912"
                            y2="284.213"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#E8521F" />
                            <stop offset="0.59" stop-color="#E86A25" />
                          </linearGradient>
                          <clipPath id="clip0_1_244">
                            <rect
                              width="124.148"
                              height="116.113"
                              fill="white"
                              transform="translate(162.275 109.873)"
                            />
                          </clipPath>
                          <clipPath id="clip1_1_244">
                            <rect
                              width="136"
                              height="131"
                              fill="white"
                              transform="translate(171 179)"
                            />
                          </clipPath>
                        </defs>
                      </SuccessImage>
                    </SuccessInnerLeft>
                    <SuccessInner>
                      <BespokeModalTitle>You're all set.</BespokeModalTitle>
                      <SuccessParagraph>
                        Thank you for avoiding your emissions with Ecologi.{" "}
                        <strong>
                          {" "}
                          Your impact will be added to your profile within 1
                          working day.
                        </strong>
                      </SuccessParagraph>
                      <SuccessParagraph>
                        Log back into your account to see the amazing projects
                        you are supporting. We also have a great set of{" "}
                        <Link
                          style={{ color: "#222222" }}
                          href="/business-toolkit"
                          target="_blank"
                          title="view our business toolkit"
                          rel="noopener"
                        >
                          assets
                        </Link>{" "}
                        that you can use to share the impact you are having with
                        Ecologi.
                      </SuccessParagraph>
                      <SuccessParagraph>
                        For any queries please contact the team on{" "}
                        <Link
                          style={{ color: "#222222" }}
                          href="mailto:albertoffsets@ecologi.com"
                          target="_blank"
                          title="send us an email"
                          rel="noopener"
                        >
                          albertoffsets@ecologi.com
                        </Link>
                      </SuccessParagraph>
                    </SuccessInner>
                  </SuccessWrapper>
                </>
              </ModalHeaderSection>
            </WideWrapper>
          </Modal>
        </SuccessModalWrapper>
      )}
    </>
  );
};
